import React from 'react';
import { Box, Toolbar, IconButton, Typography, Button, useMediaQuery } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { lightColours, darkColours } from '../styles/colours'; // Assuming you're using predefined color palette
import { Link } from 'react-router-dom'; // For navigation between pages
import logo from '../assets/logo.png'; // Assuming the logo is saved in the assets folder

const Header = ({ isMobile, toggleSidebar }) => {
  const hideHeaderLinks = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  return (
    <Box sx={{
      bgcolor: lightColours.header,
      pt: 2, pr: 0, pb: 2, pl: 2,
      borderBottom: `1px solid #ECECEC`,
    }}>
      <Toolbar>
        {/* Mobile Sidebar Button */}
        {isMobile && (
          <IconButton color="inherit" edge="start" onClick={toggleSidebar} sx={{ mr: 2 }}>
            <MenuIcon />
          </IconButton>
        )}

        {/* Logo and Site Name */}
        <Box 
          component={Link} 
          to="/" 
          sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            textDecoration: 'none', 
            flexGrow: 1 
          }}
        >
          <Box 
            component="img" 
            src={logo} 
            alt="SalaryTools Logo" 
            sx={{ height: 40, width: 40, mr: 1 }} // Adjust size as needed
          />
          <Typography 
            variant="h6" 
            sx={{
              color: darkColours.darkGrey,
              fontSize: '24px', 
              letterSpacing: '1px', 
              cursor: 'pointer',
              '&:hover': { color: lightColours.darkBlue },
            }}
          >
            SalaryTools.co.uk
          </Typography>
        </Box>

        {/* Links directly in the header */}
        {!hideHeaderLinks && (
        <Box sx={{ display: 'flex', gap: 3, fontSize: '16px' }}>
          <Button
            component={Link}
            to="/salary-calculator"
            sx={{
              color: darkColours.darkGrey,
              textDecoration: 'none',
              '&:hover': {
                color: lightColours.darkBlue,
                textDecoration: 'none',
              },
            }}
          >
            UK Take Home Pay Calculator
          </Button>
        </Box>
      )}
      </Toolbar>
    </Box>
  );
};

export default Header;
